module.exports = __webpack_public_path__ + "img/Kathryn.a2284a4c.jpg";